import { render, staticRenderFns } from "./DameraDetailInfo.vue?vue&type=template&id=bf29b8ba&scoped=true&"
import script from "./DameraDetailInfo.vue?vue&type=script&lang=ts&"
export * from "./DameraDetailInfo.vue?vue&type=script&lang=ts&"
import style0 from "./DameraDetailInfo.vue?vue&type=style&index=0&id=bf29b8ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf29b8ba",
  null
  
)

component.options.__file = "DameraDetailInfo.vue"
export default component.exports